import type { Filters } from '@/features/filters';
import type { OrganizationRole, ViewsRestrictions } from '@/entities/session';
import type {
  DimensionColumnDataType,
  DimensionDataFormatType,
} from '@/shared/types';

export enum UserStatus {
  ACTIVE = 'active',
  DEACTIVATED = 'deactivated',
}

export enum CLSType {
  BLACKLIST = 'blacklist',
  WHITELIST = 'whitelist',
}

export interface CLSFilters {
  type: CLSType;
  columns: string[];
}

export interface UserSettingsMeta {
  clsColumns: string[];
  rlsColumns: string[];
  config: Record<
    string,
    {
      name: string;
      description: string;
      group: string;
      dataType: DimensionDataFormatType;
      type: DimensionColumnDataType;
      order: number;
    }
  >;
}

export interface User {
  id: string;
  email: string;
  role: OrganizationRole;
  isActive: boolean;
  lastActiveAt?: string;
  rlsFilters: Filters;
  clsFilters: CLSFilters;
  viewsRestrictions: ViewsRestrictions;
}
